export enum DistanceUnit {
  KILOMETERS = 'KILOMETERS',
  MILES      = 'MILES',
}
